import { Typography } from '@breetometer/components';

import { getTransactionType, type ITableColumnType } from '../../WalletTransactions.helpers';

const TableColumnType = ({ row }: ITableColumnType) => <Typography as='p'>{getTransactionType(row)}</Typography>;

export default TableColumnType;
